/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Membership_Confirmations_Paid_By_Someone_Else_HintInputs */

const en_admin_membership_confirmations_paid_by_someone_else_hint = /** @type {(inputs: Admin_Membership_Confirmations_Paid_By_Someone_Else_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Will this member be paid for by somebody else? Set this up before confirming them.`)
};

const nl_admin_membership_confirmations_paid_by_someone_else_hint = /** @type {(inputs: Admin_Membership_Confirmations_Paid_By_Someone_Else_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wordt dit lid door iemand anders betaald? Stel dit in vóór je ze bevestigt.`)
};

/** @type {(inputs: Admin_Membership_Confirmations_Paid_By_Someone_Else_HintInputs) => LocalizedString} */
const de_admin_membership_confirmations_paid_by_someone_else_hint = en_admin_membership_confirmations_paid_by_someone_else_hint;

/** @type {(inputs: Admin_Membership_Confirmations_Paid_By_Someone_Else_HintInputs) => LocalizedString} */
const es_admin_membership_confirmations_paid_by_someone_else_hint = en_admin_membership_confirmations_paid_by_someone_else_hint;

/** @type {(inputs: Admin_Membership_Confirmations_Paid_By_Someone_Else_HintInputs) => LocalizedString} */
const fr_admin_membership_confirmations_paid_by_someone_else_hint = en_admin_membership_confirmations_paid_by_someone_else_hint;

/** @type {(inputs: Admin_Membership_Confirmations_Paid_By_Someone_Else_HintInputs) => LocalizedString} */
const it_admin_membership_confirmations_paid_by_someone_else_hint = en_admin_membership_confirmations_paid_by_someone_else_hint;

/** @type {(inputs: Admin_Membership_Confirmations_Paid_By_Someone_Else_HintInputs) => LocalizedString} */
const pt_br2_admin_membership_confirmations_paid_by_someone_else_hint = en_admin_membership_confirmations_paid_by_someone_else_hint;

/** @type {(inputs: Admin_Membership_Confirmations_Paid_By_Someone_Else_HintInputs) => LocalizedString} */
const pl_admin_membership_confirmations_paid_by_someone_else_hint = en_admin_membership_confirmations_paid_by_someone_else_hint;

/** @type {(inputs: Admin_Membership_Confirmations_Paid_By_Someone_Else_HintInputs) => LocalizedString} */
const hu_admin_membership_confirmations_paid_by_someone_else_hint = en_admin_membership_confirmations_paid_by_someone_else_hint;

/** @type {(inputs: Admin_Membership_Confirmations_Paid_By_Someone_Else_HintInputs) => LocalizedString} */
const ro_admin_membership_confirmations_paid_by_someone_else_hint = en_admin_membership_confirmations_paid_by_someone_else_hint;

/**
* | output |
* | --- |
* | "Will this member be paid for by somebody else? Set this up before confirming them." |
*
* @param {Admin_Membership_Confirmations_Paid_By_Someone_Else_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_membership_confirmations_paid_by_someone_else_hint = /** @type {((inputs?: Admin_Membership_Confirmations_Paid_By_Someone_Else_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Membership_Confirmations_Paid_By_Someone_Else_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_membership_confirmations_paid_by_someone_else_hint(inputs)
	if (locale === "de") return de_admin_membership_confirmations_paid_by_someone_else_hint(inputs)
	if (locale === "es") return es_admin_membership_confirmations_paid_by_someone_else_hint(inputs)
	if (locale === "fr") return fr_admin_membership_confirmations_paid_by_someone_else_hint(inputs)
	if (locale === "nl") return nl_admin_membership_confirmations_paid_by_someone_else_hint(inputs)
	if (locale === "it") return it_admin_membership_confirmations_paid_by_someone_else_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_membership_confirmations_paid_by_someone_else_hint(inputs)
	if (locale === "pl") return pl_admin_membership_confirmations_paid_by_someone_else_hint(inputs)
	if (locale === "hu") return hu_admin_membership_confirmations_paid_by_someone_else_hint(inputs)
	return ro_admin_membership_confirmations_paid_by_someone_else_hint(inputs)
});
export { admin_membership_confirmations_paid_by_someone_else_hint as "admin.membership_confirmations.paid_by_someone_else_hint" }